import React, { ButtonHTMLAttributes, FunctionComponent } from 'react';

import BaseButton from '../BaseButton';
import styleClassNames from './styles.module.scss';

interface SecondaryButtonProps {
  icon?: string;
  iconSize?: number;
  isLoading?: boolean;
  loadingCopy?: string;
  size?: ButtonSize;
}

type ButtonSize = 'small' | 'medium' | 'large';

const SecondaryButton: FunctionComponent<SecondaryButtonProps & ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  const baseProps = {
    ...props,
    styleClassNames,
    variantName: 'secondary',
  };

  return <BaseButton {...baseProps} />;
};

export default SecondaryButton;
